<template>
	<div class="prayerContainer">
		<div v-for="(prayer) in prayers" :key="prayer.time" class="prayerDiv">
			<span v-if="prayer.visDate">{{prayer.legibleDate}}<br/></span>{{prayer.prayer}} <span class="prayerMessageTag"><transition name="fade" mode="out-in"><a class="prayForClick" href="javascript:;" @click="submitPrayer(prayer)" v-if="!prayer.note">{{prayerClickMessage}}</a><span class="prayedForMessage" v-else>{{prayer.note}}</span></transition></span>
		</div>
	</div>
</template>

<script setup>

import {ref, computed, defineProps, reactive, onBeforeMount} from "vue";

import prayerService from "@/services/prayerService.js"
import {format, isSameDay} from 'date-fns';

const props = defineProps(["client"]);
const prayers = ref([]);



function submitPrayer(prayer){
	prayerService.setPrayer(props.client, prayer.prayerId).then(success => {
		if(success){
			prayer.note = "Thank you for praying for me :)";
		}
	});
}

const prayerClickMessage = computed(() => {
	return "Click here if you prayed for me"
});


onBeforeMount(() => {
	prayerService.getPrayers(props.client).then(newPrayers => {
		
		let sortedPrayers = newPrayers.sort((a,b)=>{
			return b.time-a.time;
		});


		let lastDate = new Date(0);
		sortedPrayers.forEach(prayer => {
			if(prayer.prayedFor){
				prayer.note = "Somebody already prayed for me!";
			}

			let prayerDate = new Date(Number(prayer.time));
			prayer.legibleDate = format(prayerDate, "MMM dd");

			prayer.visDate= !isSameDay(lastDate, prayerDate)
			lastDate = prayerDate;

		});

		prayers.value = sortedPrayers;

	})
})
</script>


<style scoped>

.prayerContainer{
	font-weight: 700;
	margin-left: auto;
	margin-right: auto;
	text-align: left;
	max-width: 90vw;
	width: 800px;

}
.prayerMessageTag{
	white-space: nowrap;
}

.prayedForMessage, .prayForClick{
	font-weight: 400;
	color: #757474;
	font-size: 14px;
	line-height: 1.6;
	letter-spacing: 0px;
	

}

.prayerDiv{
	margin-bottom: 20px;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>